module.exports = __webpack_public_path__ + "7679f694531284d30b854090eaf0483d.svg";